/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.5075 3.8716c-.9059-.979-2.4339-1.0381-3.4129-.1322-.9789.906-1.0381 2.434-.1322 3.413.9059.9789 2.4339 1.038 3.4129.1321.9789-.906 1.0381-2.434.1322-3.4129Zm-2.3193 1.0495a.805.805 0 1 1 1.0935 1.1817.805.805 0 1 1-1.0935-1.1817Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.9573 3.5396c-.009-1.5283-1.1831-2.797-2.7061-2.9242L14.0034.0102a2.9517 2.9517 0 0 0-2.2504.7751L.947 10.7854c-1.1966 1.1073-1.269 2.9748-.1617 4.1713l7.2904 7.878c1.1073 1.1965 2.9748 1.2688 4.1713.1616l10.8061-10.0001a2.9517 2.9517 0 0 0 .9468-2.1838l-.0426-7.2728ZM21.1172 2.22c.6923.0578 1.226.6345 1.23 1.3292l.0427 7.2728a1.3418 1.3418 0 0 1-.4304.9926l-10.806 10.0001c-.5439.5033-1.3928.4704-1.896-.0735l-7.2905-7.878c-.5033-.5438-.4704-1.3927.0735-1.896l10.806-10a1.342 1.342 0 0 1 1.023-.3524l7.2477.6052Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Tag'
);
